import * as yup from 'yup';
import RandomSampleFormModel from './randomSampleFormModel';

const { formField: {
  NumberOfYearsToCheckPreviousValidations,
  PercentageOfActiveUsers } } = RandomSampleFormModel;

export const RandonSampleValidationSchemas = yup.object().shape({
  [NumberOfYearsToCheckPreviousValidations.name]: yup.string().required(NumberOfYearsToCheckPreviousValidations.requiredErrorMsg),
  [PercentageOfActiveUsers.name]: yup.number().required(PercentageOfActiveUsers.requiredErrorMsg)
    .typeError(PercentageOfActiveUsers.typeErrorMsg)
});
